/**
 * GardenState — persistent per-room state.
 * Bridges the client to the server's /room_state endpoints so bloomed
 * plants, the secret 5th plant, and tend counts survive across sessions.
 */

const STATE_URL = (roomCode) => `https://farm-api.jacobterrell.dev/heirloom/room_state/${encodeURIComponent(roomCode)}`;

class GardenStateClass {
  constructor() {
    this.roomCode = null;
    this.state = {
      bloomedPlants: [],
      tendCounts: {},
      secretPlant: null,
      totalVisits: 0,
    };
  }

  async load(roomCode) {
    this.roomCode = roomCode;
    try {
      const res = await fetch(STATE_URL(roomCode));
      if (!res.ok) return this.state;
      const json = await res.json();
      if (json?.state) this.state = { ...this.state, ...json.state };
      return this.state;
    } catch (_) {
      return this.state;
    }
  }

  async increment(patch) {
    if (!this.roomCode) return;
    // Optimistic local update
    if (patch.bloomPlant && !this.state.bloomedPlants.includes(patch.bloomPlant)) {
      this.state.bloomedPlants.push(patch.bloomPlant);
      this.state.tendCounts[patch.bloomPlant] = (this.state.tendCounts[patch.bloomPlant] || 0) + 1;
    } else if (patch.tendPlant) {
      this.state.tendCounts[patch.tendPlant] = (this.state.tendCounts[patch.tendPlant] || 0) + 1;
    }
    if (patch.secretPlant) this.state.secretPlant = patch.secretPlant;
    if (patch.incrementVisit) this.state.totalVisits = (this.state.totalVisits || 0) + 1;
    // Fire-and-forget to server
    try {
      await fetch(STATE_URL(this.roomCode), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(patch),
      });
    } catch (_) {}
  }

  isBloomed(plantId) {
    return this.state.bloomedPlants.includes(plantId);
  }

  tendCount(plantId) {
    return this.state.tendCounts[plantId] || 0;
  }

  getSecretPlant() {
    return this.state.secretPlant;
  }
}

export const GardenState = new GardenStateClass();
